module.exports = __webpack_public_path__ + "static/img/g60-video.ad996596.png";